import { Link } from "react-router-dom";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { cld, money, dims } from "@/lib/api";

export const FeaturedCarousel = ({ items }) => (
  <Carousel opts={{ align: "start", loop: items.length > 3 }} data-testid="featured-carousel">
    <CarouselContent className="-ml-8">
      {items.map((p) => (
        <CarouselItem key={p.id} className="basis-[85%] pl-8 sm:basis-1/2 lg:basis-1/3">
          <Link to={`/artwork/${p.slug}`} className="group block" data-testid={`featured-item-${p.slug}`}>
            <div className="relative aspect-[4/5] overflow-hidden bg-[#F2EEE6]">
              <img src={cld(p.images?.[0], "w_900,q_auto,f_auto")} alt={p.title} className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.035]" />
              {p.isSold && <span className="absolute left-5 top-5 bg-[#1A1A1A] px-3 py-1.5 text-[10px] tracking-[0.3em] text-[#FDFBF7]">SOLD</span>}
            </div>
            <div className="mt-5 flex items-baseline justify-between gap-4">
              <h3 className="font-display text-2xl">{p.title}</h3>
              <span className="text-sm text-[#5A626A]">{p.isSold ? "Sold" : money(p.price)}</span>
            </div>
            <p className="mt-1 text-xs text-[#5A626A]">{dims(p)}</p>
          </Link>
        </CarouselItem>
      ))}
    </CarouselContent>
    <div className="mt-10 flex gap-3">
      <CarouselPrevious data-testid="featured-prev" className="static translate-y-0 rounded-none border-[#1A1A1A] bg-transparent" />
      <CarouselNext data-testid="featured-next" className="static translate-y-0 rounded-none border-[#1A1A1A] bg-transparent" />
    </div>
  </Carousel>
);
